import IFellowshipPost from "../../interfaces/IFellowshipPost";
import IApiResponse from "../../interfaces/IApiResponse";
import DexieDB from '../../data/DexieDB'
import SuccessApiResponse from "../../data/SuccessApiResponse";
import { IFellowshipPostService } from "../FellowshipPostService";

const FellowshipPostServiceWeb: IFellowshipPostService = {
    createFellowshipPost: (fellowshipPost) => {
        const dbResponse: Promise<IApiResponse<IFellowshipPost>> = DexieDB.transaction('rw', DexieDB.fellowshipPosts, async()  => {
            const newFellowshipPost: any  = fellowshipPost;
            // delete newFellowshipPost.id;
            return DexieDB.fellowshipPosts.add({...newFellowshipPost}).then((fellowshipPostId)=>{
                fellowshipPost.id = fellowshipPostId;
                const response = {...SuccessApiResponse, Data: fellowshipPost};
                response.Message.UserMessage = 'SUCCESS: ADDED NEW POST.';
                return response;
            });
        }).catch((error)=>{
            const response = {
                Data: fellowshipPost,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IFellowshipPost>;
        });

        return dbResponse;
    },

    getFellowshipPost: (fellowshipPostId) =>  {
        const dbResponse: Promise<IApiResponse<IFellowshipPost>> = DexieDB.transaction('r', DexieDB.fellowshipPosts, async()  => {
            return DexieDB.fellowshipPosts.get(fellowshipPostId).then((result)=>{
                if(result) {
                    return  {...SuccessApiResponse, Data: result};
                } else {
                    return {
                        Data: undefined,
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND POST', ServerMessage: 'FAILED TO GET' }
                    }
                }
            });
        }).catch((error)=>{
            const response = {
                Data: undefined,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IFellowshipPost>;
        });

        return dbResponse;
    },

    getAllFellowshipPosts: () => {
        const dbResponse: Promise<IApiResponse<IFellowshipPost[]>> = DexieDB.transaction('r', DexieDB.fellowshipPosts, async()  => {
                return  DexieDB.fellowshipPosts.orderBy('sortDate').toArray().then(fellowshipPosts => {
                    return {...SuccessApiResponse, Data: fellowshipPosts};
                })
        }).catch((error)=>{
            const response = {
                Data: undefined,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IFellowshipPost[]>;
        });

        return dbResponse;
    },

    getAllGroupFellowshipPosts: (groupId: string) => {
        const dbResponse: Promise<IApiResponse<IFellowshipPost[]>> = DexieDB.transaction('r', DexieDB.fellowshipPosts, async()  => {
                return  DexieDB.fellowshipPosts.where({groupId: groupId}).reverse().sortBy('sortDate').then(fellowshipPosts => {
                    return {...SuccessApiResponse, Data: fellowshipPosts};
                })
        }).catch((error)=>{
            const response = {
                Data: undefined,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IFellowshipPost[]>;
        });

        return dbResponse;
    },

    getLastSortDate: (groupId: string) => {
        const dbResponse: Promise<IApiResponse<Date>> = DexieDB.transaction('r', DexieDB.fellowshipPosts, async()  => {
            return DexieDB.fellowshipPosts.where({groupId: groupId}).reverse().sortBy('sortDate').then((result)=>{
                if(result && result.length) {
                    const lastSortDate = result[0].sortDate;
                    return  {...SuccessApiResponse, Data: lastSortDate ? lastSortDate : 0} as IApiResponse<Date>;
                } else {
                    return {
                        Data: new Date(0),
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND POST', ServerMessage: 'FAILED TO GET' }
                    } as IApiResponse<Date>
                }
            });
        }).catch((error)=>{
            const response = {
                Data: new Date(0),
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<Date>;
        });

        return dbResponse;
    },

    getLastModifiedDate: (groupId: string) => {
        const dbResponse: Promise<IApiResponse<Date>> = DexieDB.transaction('r', DexieDB.fellowshipPosts, async()  => {
            return DexieDB.fellowshipPosts.where({groupId: groupId}).reverse().sortBy('modifiedDate').then((result)=>{
                if(result && result.length) {
                    const lastModifiedDate = result[0].modifiedDate;
                    return  {...SuccessApiResponse, Data: lastModifiedDate ? lastModifiedDate : 0} as IApiResponse<Date>;
                } else {
                    return {
                        Data: new Date(0),
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND POST', ServerMessage: 'FAILED TO GET' }
                    } as IApiResponse<Date>
                }
            });
        }).catch((error)=>{
            const response = {
                Data: new Date(0),
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<Date>;
        });

        return dbResponse;
    },

    getOlderPosts:  (groupId: string, lastSortDate: Date, limit: number) => {
        const dbResponse: Promise<IApiResponse<IFellowshipPost[]>> = DexieDB.transaction('r', DexieDB.fellowshipPosts, async()  => {
            // set search date less than lastSortDate to make sure we don't get the lastSortDate post
            const searchDate = new Date(lastSortDate);
            searchDate.setMilliseconds(lastSortDate.getMilliseconds() - 1);
            // Select top(limit) * from fellowshipPosts where groupId = groupId order by sortDate DESC
            return  DexieDB.fellowshipPosts
                .where('[groupId+sortDate]')
                .between(
                    [groupId, new Date(0)], 
                    [groupId, searchDate], 
                    true, true)
                .reverse()
                .limit(limit)
                .toArray()
                .then(fellowshipPosts => {
                    return {...SuccessApiResponse, Data: fellowshipPosts};
                })
        }).catch((error)=>{
            const response = {
                Data: undefined,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IFellowshipPost[]>;
        });

        return dbResponse;
    },

    updateFellowshipPost: (fellowshipPost) => {
        const updatedFellowshipPost = {...fellowshipPost};
        const dbResponse: Promise<IApiResponse<IFellowshipPost>> = DexieDB.transaction('rw', DexieDB.fellowshipPosts, async()  => {
            return DexieDB.fellowshipPosts.put(updatedFellowshipPost).then((result)=>{
                const response = {...SuccessApiResponse, Data: fellowshipPost};
                response.Message.UserMessage = 'SUCCESS: UPDATED POST.';
                return response;
            });
        }).catch((error)=>{
            const response = {
                Data: fellowshipPost,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IFellowshipPost>;
        });

        return dbResponse;
    },

    updateFellowshipPosts: (fellowshipPosts) => {
        // Check that no added posts were previously marked as hidden
        // const updatedPost = await fellowshipPosts.filter(async post => {
        //     const dbPost = await FellowshipPostServiceWeb.getFellowshipPost(post.id);
        // });

        const dbResponse: Promise<IApiResponse<boolean>> = DexieDB.transaction('rw', DexieDB.fellowshipPosts, async()  => {
            return DexieDB.fellowshipPosts.bulkPut(fellowshipPosts).then((result)=>{
                return {...SuccessApiResponse, Data: true};
            });
        }).catch((error)=>{
            const response = {
                Data: false,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<boolean>;
        });

        return dbResponse;
    },

    // This is no longer used so that syncing with the cloud will know to remove it from other devices
    deleteFellowshipPost: (fellowshipPost) => {
        const dbResponse: Promise<IApiResponse<boolean>> = DexieDB.transaction('rw', DexieDB.fellowshipPosts, async()  => {
            return DexieDB.fellowshipPosts.delete(fellowshipPost.id).then((result)=>{
                return {...SuccessApiResponse, Data: true};
            });
        }).catch((error)=>{
            const response = {
                Data: false,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<boolean>;
        });

        return dbResponse;
    },
}

export default FellowshipPostServiceWeb;